"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _reactI18next = require("react-i18next");
var _userContext = _interopRequireDefault(require("../../context/userContext"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  ratingBox: {
    border: "1px solid " + theme.palette.primary.main,
    margin: "0 auto",
    padding: theme.spacing(4),
    textAlign: "center"
  },
  ratingTitle: {
    ...theme.customTypography.ratingTitle
  },
  ratingText: {
    margin: theme.spacing(2, 0)
  },
  ratingValue: {
    marginTop: theme.spacing(2)
  },
  ratingLabel: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold
  },
  ratingForm: {
    margin: "0 auto",
    maxWidth: "500px"
  },
  icon: {
    color: theme.palette.primary.main
  },
  button: {
    marginTop: theme.spacing(4)
  }
}));
const Rating = _ref => {
  let {
    employeeID,
    name
  } = _ref;
  const [userData] = (0, _react.useContext)(_userContext.default);
  const ref = (0, _react.useRef)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  const [value, setValue] = (0, _react.useState)(null);
  const [ratingResponse, setRatingResponse] = (0, _react.useState)({});
  const labels = {
    1: t("site.team.ratings.0"),
    2: t("site.team.ratings.1"),
    3: t("site.team.ratings.2"),
    4: t("site.team.ratings.3"),
    5: t("site.team.ratings.4")
  };
  const submitRating = async () => {
    var _userData$roomNumber, _ref$current$value, _ref$current;
    const {
      REACT_APP_PATH
    } = process.env;
    const formData = new FormData();
    formData.append("Addition", (_userData$roomNumber = userData === null || userData === void 0 ? void 0 : userData.roomNumber) !== null && _userData$roomNumber !== void 0 ? _userData$roomNumber : "");
    formData.append("EmployeeID", employeeID);
    formData.append("Name", userData !== null && userData !== void 0 && userData.firstname && userData !== null && userData !== void 0 && userData.lastname ? "".concat(userData === null || userData === void 0 ? void 0 : userData.firstname, " ").concat(userData === null || userData === void 0 ? void 0 : userData.lastname) : "");
    formData.append("Rating", value);
    formData.append("Remarks", (_ref$current$value = ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.value) !== null && _ref$current$value !== void 0 ? _ref$current$value : "");
    const response = await fetch("".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/RateEmployee.api"), {
      method: "POST",
      body: formData
    });
    const result = await response.json();
    setRatingResponse(result);
    saveRating(employeeID, value);
  };
  const saveRating = (employeeID, ratingValue) => {
    if (!employeeID || !ratingValue) return null;
    const newRating = {
      employeeID,
      ratingValue
    };
    try {
      const currentRatings = JSON.parse(localStorage.getItem("teamRating"));
      if (!currentRatings) {
        localStorage.setItem("teamRating", JSON.stringify([newRating]));
      } else {
        currentRatings.push(newRating);
        localStorage.setItem("teamRating", JSON.stringify(currentRatings));
      }
    } catch (error) {
      localStorage.setItem("teamRating", JSON.stringify([newRating]));
    }
  };
  const NewRating = () => {
    const [remarks, setRemarks] = (0, _react.useState)("");
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: css.ratingTitle
    }, /*#__PURE__*/_react.default.createElement("span", null, t("site.team.ratingTitle"))), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: css.ratingText
    }, t("site.team.ratingText")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
      dangerouslySetInnerHTML: {
        __html: name
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: css.ratingValue
    }, /*#__PURE__*/_react.default.createElement(_lab.Rating, {
      name: "hover-feedback",
      value: value,
      classes: {
        iconFilled: css.icon
      },
      size: "large",
      precision: 1,
      onChange: (event, newValue) => {
        setValue(newValue);
      }
    }), value !== null && /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: css.ratingLabel,
      ml: 0,
      mt: 1
    }, labels[value])), value && /*#__PURE__*/_react.default.createElement("div", {
      className: css.ratingForm
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      mt: 4
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      inputRef: ref,
      fullWidth: true,
      label: t("site.ui.labels.remark"),
      multiline: true,
      minRows: 4,
      variant: "outlined",
      value: remarks,
      onChange: event => setRemarks(event.target.value)
    })), /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "contained",
      onClick: () => {
        submitRating();
      },
      color: "primary",
      className: css.button
    }, t("site.team.ratingButton"))));
  };
  const BackButton = () => {
    const history = (0, _reactRouterDom.useHistory)();
    return /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "contained",
      onClick: () => {
        history.goBack();
      },
      color: "primary",
      className: css.button
    }, t("site.team.ratingBackButton"));
  };
  const RatingResponse = () => {
    if (ratingResponse.state === 0) {
      return /*#__PURE__*/_react.default.createElement(RatingOK, null);
    } else {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, t("site.team.ratingError")), /*#__PURE__*/_react.default.createElement(BackButton, null));
    }
  };
  const RatingOK = () => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, t("site.team.ratingSuccess")), /*#__PURE__*/_react.default.createElement(BackButton, null));
  };
  const RenderRating = () => {
    if (!(0, _lodash.isEmpty)(ratingResponse)) {
      return /*#__PURE__*/_react.default.createElement(RatingResponse, null);
    }
    return /*#__PURE__*/_react.default.createElement(NewRating, null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _lodash.isEmpty)(userData) && userData.state !== 1 && /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.ratingBox
  }, /*#__PURE__*/_react.default.createElement(RenderRating, null)));
};
var _default = exports.default = Rating;